type VisualViewportMeasurements = Pick<VisualViewport, "height" | "offsetTop">;

type MobileBottomSheetViewport = {
	bottomInset: number;
	visibleHeight: number;
};

function normalizeDimension(value: number | undefined): number {
	return Number.isFinite(value) && Number(value) > 0 ? Number(value) : 0;
}

export function getMobileBottomSheetViewport(
	innerHeight: number,
	visualViewport?: VisualViewportMeasurements | null
): MobileBottomSheetViewport {
	const layoutHeight = normalizeDimension(innerHeight);
	const measuredVisualHeight = normalizeDimension(visualViewport?.height);
	const visualHeight = layoutHeight && measuredVisualHeight ? Math.min(layoutHeight, measuredVisualHeight) : measuredVisualHeight || layoutHeight;
	const viewportOffsetTop = Math.max(0, Number.isFinite(visualViewport?.offsetTop) ? Number(visualViewport?.offsetTop) : 0);
	const effectiveLayoutHeight = layoutHeight || visualHeight;

	return {
		bottomInset: Math.max(0, effectiveLayoutHeight - (viewportOffsetTop + visualHeight)),
		visibleHeight: visualHeight
	};
}
